import { BreakpointTrackerContext } from '@jutro/layout';
import { Loader, useModal } from '@jutro/components';
import { useAuthentication } from '@xengage/gw-digital-auth-react';
import { ViewModelForm, ViewModelServiceContext } from '@xengage/gw-portals-viewmodel-react';
import { WizardPage, wizardProps } from '@xengage/gw-portals-wizard-react';
import _ from 'lodash';
import { TranslatorContext } from '@jutro/locale';
import React, { useCallback, useContext, useEffect, useState } from 'react';
import { LoadSaveService } from 'twia-capability-quoteandbind-residential';
import { useValidation } from '@xengage/gw-portals-validation-react';
import msbInfoUtil from 'ent-capability-quoteandbind-common-react/util/MsbInfoUtil.js';
import ErrorPopupUtil from 'ent-components-platform-react/util/ErrorPopupUtil';
import metadata from './PropertyDetailsPage.metadata.json5';
import styles from './PropertyDetailsPage.module.scss'
import AddressDetails from '../../components/PropertyDetails/AddressDetails/AddressDetails';
import LocationDetails from '../../components/PropertyDetails/LocationDetails/LocationDetails';
import DwellingDetails from '../../components/PropertyDetails/DwellingDetails/DwellingDetails';
import TWIACleanseObjUtil from '../../../twia-capability-quoteandbind-TWIAResidential-react/util/TWIACleanseObjUtil';

function TFPAPropertyDetailsPage(props) {
    const breakpoint = useContext(BreakpointTrackerContext);
    const { wizardData: submissionVM, updateWizardData, id, steps } = props;
    const { authHeader } = useAuthentication();
    const translator = useContext(TranslatorContext);
    const viewModelService = useContext(ViewModelServiceContext);
    const [isLoading, setIsLoading] = useState(false);
    const [showErrors, setShowErrors] = useState(false);
    const [showErrorMessage, setShowErrorMessage] = useState(false);
    const [errorDescription, setShowErrorDescription] = useState();
    const [yourHomeVM, setYourHomeVM] = useState(submissionVM.lobData.homeowners_tfpa.coverables.yourHome);
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const [homeownersVM, setHomeOwnersVM] = useState(submissionVM.lobData.homeowners_tfpa);
    const [showMessage, setShowMessage] = useState(false);
    const [invalidComponent, setInvalidComponents] = useState([]);
    const { showAlert } = useModal();
    const {
        initialValidation,
        onValidate
    } = useValidation(id);

    const updateSubmissionVM = useCallback((homeVM) => {
        setYourHomeVM(homeVM);
        _.set(submissionVM, 'lobData.homeowners_tfpa.coverables.yourHome', homeVM);
        updateWizardData(submissionVM);
    }, [submissionVM, updateWizardData]);

    useEffect(() => {
        TWIACleanseObjUtil.resetAspectsNotVisibleValues(submissionVM.lobData.homeowners_tfpa.coverables.yourHome);
    }, [])

    const validateCompanion = useCallback(() =>
        // eslint-disable-next-line no-secrets/no-secrets
        _.get(yourHomeVM, 'haveCompanionPolicy_TWIA.aspects.required') === true,
        [yourHomeVM]);

    const findInvalidComponent = useCallback((isValid, componentID) => {
        if (isValid === false) {
            setInvalidComponents((oldValue) => [...oldValue, componentID]);
        }

        if (isValid === true) {
            setInvalidComponents((oldValue) => oldValue.filter((val) => val !== componentID));
        }
    }, []);

    const resetAllCodes = () => {
        _.set(yourHomeVM, 'primaryAddress.territoryCode_Ext.value.code', '');
        _.set(yourHomeVM, 'dwellingProtectionClassCode_Ext.value', '');
         _.set(yourHomeVM, 'primaryAddress.eastOfHighway146_Ext.value', undefined);
        _.set(yourHomeVM, 'primaryAddress.county', '');
        setShowMessage(true);
    };


    //US10877 - Review MSB
    const getUrlAndOpen = ()=>{
        msbInfoUtil(submissionVM, updateWizardData, authHeader).getReviewMSBUrl(submissionVM.lobData.homeowners_tfpa.policy.policyNumber);    
    };

    
    // eslint-disable-next-line arrow-body-style
    const enableApplyCodes = useCallback(() => {
        return (
            !_.includes(invalidComponent, 'AddressDetails') &&
            !_.includes(invalidComponent, 'DwellingDetails') &&
            _.get(yourHomeVM, 'distanceToFireHydrant.aspects.valid') &&
            _.get(yourHomeVM, 'distanceToFireStation.aspects.valid') &&
            (!_.get(yourHomeVM, 'dwellingProtectionClassCode_Ext')?.value ||
                _.get(yourHomeVM, 'dwellingProtectionClassCode_Ext')?.value === '') &&
            (!_.get(yourHomeVM, 'primaryAddress.territoryCode_Ext') ||
                !_.get(yourHomeVM, 'primaryAddress.territoryCode_Ext')?.code?.value ||
                _.get(yourHomeVM, 'primaryAddress.territoryCode_Ext')?.code?.value === '')
        );
    }, [invalidComponent, yourHomeVM]);
    
    const overrideProps = {
        '@field': {
            // apply to all fields
            showOptional: true,
            labelPosition: breakpoint === 'desktop' ? 'left' : 'top',
        },
        addressDetailsAccordion: {
            errorState: _.includes(invalidComponent, 'AddressDetails') && showErrors
        },
        addressDetailsSection: {
            yourHomeVM,
            updateSubmissionVM,
            showErrors,
            findInvalidComponent,
            onValidate,
            submissionVM,
            steps,
            resetAllCodes

        },
        locationDetailsAccordion: {
            errorState: _.includes(invalidComponent, 'LocationDetails') && showErrors
        },
        locationDetailsSection: {
            yourHomeVM,
            updateSubmissionVM,
            showErrors,
            findInvalidComponent,
            onValidate,
            submissionVM,
            invalidComponent,
            enableApplyCodes,
            resetAllCodes,
            showMessage,
            setShowMessage
        },
        dwellingDetailsAccordion: {
            errorState: _.includes(invalidComponent, 'DwellingDetails') && showErrors
        },
        dwellingDetailsSection: {
            yourHomeVM,
            homeownersVM,
            updateSubmissionVM,
            showErrors,
            findInvalidComponent,
            onValidate,
            submissionVM,
            steps
        },
        infoMessage: {
            visible: showErrorMessage,
            message: errorDescription
        },
        accordionBreak: {
            visible: showErrorMessage
        }
    };

    const onNext = useCallback(async () => {
        if (invalidComponent.length > 0) {
            setShowErrors(true)

            return false;
        }

        setShowErrors(false);

        //const isMSBUrlAvailable = false;
        if (_.get(submissionVM,'lobData.homeowners_tfpa.policy.policyNumber.value') !== undefined ){
            msbInfoUtil(submissionVM, updateWizardData, authHeader).checkMSBUrlAvailability(_.get(submissionVM,'lobData.homeowners_tfpa.policy.policyNumber.value'))
        }

        try {
            const newSubmissionVM = viewModelService.clone(submissionVM);
            const policyTypeCode = _.get(submissionVM, 'lobData.homeowners_tfpa.policyType_TWIA.value.code')

            // US26300
            TWIACleanseObjUtil.resetAspectsNotVisibleValues(newSubmissionVM);
            _.set(newSubmissionVM, 'lobData.homeowners_tfpa.coverables.construction', undefined);
            _.set(newSubmissionVM, 'lobData.homeowners_tfpa.offerings', undefined);

             if(policyTypeCode === 'HO4'){
                _.set(newSubmissionVM, 'lobData.homeowners_tfpa.coverables.yourHome.occupancy.value',undefined)
             }

             if(policyTypeCode === 'HO3'){
                _.set(newSubmissionVM, 'lobData.homeowners_tfpa.coverables.yourHome.occupantRelationShipType_ext.value',undefined)
             }

            submissionVM.value = await LoadSaveService.updateDraftSubmission(
                newSubmissionVM.value,
                authHeader
            )
            updateWizardData(submissionVM);

           // const { validationIssues } = submissionVM.value.errorsAndWarnings;

            // if (validationIssues && validationIssues.issues && validationIssues.issues.length > 0) {
            //     if (validationIssues.issues[0].flowStepId === "HomeownersDwelling") {
            //         setShowErrorMessage(true);
            //         setShowErrorDescription(validationIssues.issues[0].reason);

            //         return false;
            //     }
            // }

            // if (validationIssues && validationIssues.fieldIssues && validationIssues.fieldIssues.length > 0) {
            //     const fieldIssueProperty = _.find(validationIssues.fieldIssues, (field) => field
            //         .flowStepId === "HomeownersDwelling");

            //     if (fieldIssueProperty) {
            //         setShowErrorMessage(true);
            //         setShowErrorDescription(fieldIssueProperty.reason);

            //         return false;
            //     }
            // }

            return submissionVM
        } catch (error) {
            ErrorPopupUtil.showSaveErrorPopup(showAlert, false);

            return false;
            // return submissionVM;
        }
    }, [authHeader, invalidComponent, showAlert, submissionVM, updateWizardData, 
        viewModelService]);

    const resolvers = {
        resolveClassNameMap: styles,
        resolveComponentMap: {
            addressDetailsComponent: AddressDetails,
            locationDetailsComponent: LocationDetails,
            dwellingDetailsComponent: DwellingDetails,
        },
        resolveCallback: {
            getUrlAndOpen
        }
    };

   

    return (
        <WizardPage
            id={id}
            onNext={onNext}
            skipWhen={initialValidation}
        >
            <Loader loaded={!isLoading}>
                <ViewModelForm
                    uiProps={metadata.pageContent}
                    model={submissionVM}
                    showErrors={showErrors}
                    overrideProps={overrideProps}
                    onModelChange={updateWizardData}
                    callbackMap={resolvers.resolveCallbackMap}
                    componentMap={resolvers.resolveComponentMap}
                    classNameMap={resolvers.resolveClassNameMap}
                />
            </Loader>
        </WizardPage>
    );
}

TFPAPropertyDetailsPage.propTypes = wizardProps;
export default TFPAPropertyDetailsPage;
